import { API } from "./api";
export const getCompanyDashboardData = () => API.get("/dashboard/companyData");
export const getOwnerDashboardData = () => API.get("/dashboard/ownerData");
